module.exports = __webpack_public_path__ + "media/images/icons/icon_time_black-457d54ec8187a0e07a058b770cf2d5cb.svg";